// src/config.js

const config = {
    // apiBaseUrl: 'http://localhost/epro_API/api'
    // apiBaseUrl: 'https://rangsakonass.in/api'
    // apiBaseUrl: 'https://thegrowingtree.co.in/api'
    apiBaseUrl: 'https://ehss.in/api'
    // apiBaseUrl: 'https://rsmss.in/api'
    // apiBaseUrl: 'https://vineyardschool.in/api'
    // apiBaseUrl: 'https://rangsaparass.in/api'
    // apiBaseUrl: 'https://gvau.in/api'
    // apiBaseUrl: 'https://assmj.in/api'
  };
  
  export default config;